import { render, staticRenderFns } from "./ComradeInfo.vue?vue&type=template&id=7680e739&scoped=true"
import script from "./ComradeInfo.vue?vue&type=script&lang=js"
export * from "./ComradeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7680e739",
  null
  
)

export default component.exports